import { SxProps, Theme } from '@mui/material/styles';
import logo from '../../assets/logo/bloomays_wordmark_logo.svg';
import Logo from '../atoms/Logo';

export type LogoBloomaysProps = {
  alt?: string;
  onClick?: () => void;
  sx?: SxProps<Theme>;
};

const LogoBloomays = ({ alt, onClick, sx }: LogoBloomaysProps) => {
  return <Logo image={logo} alt={alt} onClick={onClick} sx={sx} />;
};

export default LogoBloomays;

export { LogoBloomays };
